import { useImageUploadMutation, useFileUploadMutation } from '../fileUploaderApi';
import { enqueueSnackbar } from 'notistack';
import { TOAST_ERROR, TOAST_SUCCESS } from '../../../utils/constants';
import i18next from 'i18next';

export const useFileUploaderActions = () => {
  const [imageUploadTrigger] = useImageUploadMutation();
  const [fileUploadTrigger] = useFileUploadMutation();

  const imageUpload = async ({ file, mockedType }) => {
    try {
      const result = await imageUploadTrigger({ file, mockedType }).unwrap();
      return result;
    } catch (err) {
      const errorMessage = err?.data?.errMsg || i18next.t('fileUploader.error');
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  const fileUpload = async (file) => {
    try {
      const result = await fileUploadTrigger(file).unwrap();
      enqueueSnackbar(i18next.t('fileUploader.success'), { variant: TOAST_SUCCESS });
      return result;
    } catch (err) {
      let errorMessage = err?.data?.errMsg || i18next.t('fileUploader.error');
      if (err?.originalStatus === 413) {
        errorMessage = i18next.t('fileUploader.fileTooLarge');
      }
      enqueueSnackbar(errorMessage, { variant: TOAST_ERROR });
      throw err;
    }
  };

  return {
    imageUpload,
    fileUpload,
  };
};
